import React, { FC } from 'react'
import { TypeNewForm, TypeNewFormProps } from '../common/newType'

type Props = Omit<TypeNewFormProps, 'placeholder'>

export const ReportComponentNewForm: FC<Props> = (props) => {
  return <TypeNewForm {...props} placeholder="New Report Component Name" />
}
